import { getQueryParam, getPathFromUrl } from "@/lib/url-helpers"

import router from "@/router"

import EventBus, { EVENTS } from "@/lib/event-bus"

// Stores a block action ID that arrived before BlockActionTrigger.vue was mounted.
// Consumed by the component in its mounted() hook to handle the race condition on
// native iOS where the push handler fires before the Vue component tree is ready.
let pendingBlockAction: string | null = null

export const consumePendingBlockAction = (): string | null => {
  const action = pendingBlockAction
  pendingBlockAction = null
  return action
}

export const handleNotificationUrl = (url: string) => {
  const blockActionQueryParam = getQueryParam(url, "block-action")

  if (blockActionQueryParam) {
    pendingBlockAction = blockActionQueryParam // store for late mounts
    EventBus.$emit(EVENTS.TRIGGER_BLOCK_ACTION, blockActionQueryParam)
  } else {
    const path = getPathFromUrl(url, true)

    if (path !== "/") router.push(path)
  }
}
